// extracted by mini-css-extract-plugin
export var progressBar = "_n2-0";
export var progressBarInner = "_n2-1";